import React from 'react';
import './Navbar.scss';
import logo from './../../assets/alsalket_cer_logo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/useTranslation';

const Navbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract language from pathname (e.g., "/en/services" -> "en", "/ar" -> "ar")
  const pathname = location.pathname;
  const langMatch = pathname.match(/^\/(en|ar)(\/|$)/);
  const currentLang = langMatch && langMatch[1] === 'ar' ? 'ar' : 'en';

  const buildPath = (path) => `/${currentLang}${path}`;

  const handleLanguageChange = (targetLang) => {
    if (targetLang === currentLang) return;
    // Replace the current /en or /ar prefix with the target language
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length === 0) {
      navigate(`/${targetLang}`, { replace: true });
      return;
    }
    // Replace first segment (language) with target language
    if (segments[0] === 'en' || segments[0] === 'ar') {
      segments[0] = targetLang;
    } else {
      // If no language prefix, prepend it
      segments.unshift(targetLang);
    }
    navigate(`/${segments.join('/')}`, { replace: true });
  };

  return (
    <div className='main-nav'>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Logo */}
            <Link className="navbar-brand" to={`/${currentLang}`}>
              <img src={logo} alt="logo" />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              {/* Navbar Link */}
              <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('')}>{t('nav.home')}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('/services')}>{t('nav.services')}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('/features')}>{t('nav.features')}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('/accredited')}>{t('nav.about')}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('/appointment')}>{t('nav.book')}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={buildPath('/contact')}>{t('nav.contact')}</Link>
                </li>
              </ul>

              {/* Language Switcher */}
              <div className="language-switcher me-3">
                <button
                  type="button"
                  className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  EN
                </button>
                <span className="mx-1">/</span>
                <button
                  type="button"
                  className={`lang-btn ${currentLang === 'ar' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('ar')}
                >
                  AR
                </button>
              </div>

              {/* Navbar Button */}
              <div className="theme-btn">
                <Link to={buildPath('/contact')}>{t('nav.bookAppointment')}</Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;